module.exports = __webpack_public_path__ + "img/img-quick-04.1f984a82.png";